webpackJsonp([10],{

/***/ "+hc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__("Nhkl");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0887938c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__("llvE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0887938c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Nhkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: [Array, Object]
  },
  created: function created() {
    var _this = this;

    window.api.get('sectors').then(function (res) {
      _this.$store.commit('updateCurrentSectors', res.data.data.data);
    });
  },

  methods: {
    getSector: function getSector(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$store.state.availableSectors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var sector = _step.value;

          if (sector.id === id) {
            return sector.name;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }
});

/***/ }),

/***/ "llvE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block intro bg-parent",style:({ backgroundColor: _vm.$getField('intro_background_colour', _vm.data), color: _vm.$getField('intro_colour', _vm.data) })},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.$getField('intro_image', _vm.data)[0]),expression:"'https://api.alt-design.net/api/image/' + $getField('intro_image', data)[0]",arg:"background-image"}],staticClass:"bg-fade"}),_vm._v(" "),_c('div',{staticClass:"intro-text",domProps:{"innerHTML":_vm._s(_vm.$getField('intro_text', _vm.data))}}),_vm._v(" "),_c('ul',{staticClass:"services"},_vm._l((_vm.$store.state.currentSectors),function(sector){return _c('li',[_vm._v(_vm._s(_vm.getSector(sector)))])})),_vm._v(" "),_c('p',{staticClass:"link"},[_c('a',{attrs:{"target":"_blank","href":_vm.$getField('intro_link', _vm.data)}},[_vm._v(_vm._s(_vm.$getField('intro_link_text', _vm.data)))])]),_vm._v(" "),_c('div',{staticClass:"block intro-mobile bg-parent",style:({ backgroundColor: _vm.$getField('intro_background_colour', _vm.data), color: _vm.$getField('intro_colour', _vm.data) })},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:('https://api.alt-design.net/api/image/' + _vm.$getField('intro_image', _vm.data)[0]),expression:"'https://api.alt-design.net/api/image/' + $getField('intro_image', data)[0]",arg:"background-image"}],staticClass:"bg-fade"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.8bd7c805429b32af0fb7.js